// ─────────────────────────────────────────────────────────────────────────────
// utils/liveAbo.ts — DIE EINE Bildungsstelle der Live-Abos
// (T-M21.4, REQ-OPS-053 (a) bis (e), (g); REQ-OPS-055 (b) — Abo-Lebenslauf)
//
// ── WOFUER ──────────────────────────────────────────────────────────────────
// Gemessen am 2026-08-18 in `dashboard/src`: zwoelf `onSnapshot`-Stellen, elf
// davon mit einem Fehler-Rueckruf — und **keine einzige nahm das Abo wieder
// auf**. Firestore beendet einen Listener nach einem Fehler ENDGUELTIG: der
// Rueckruf laeuft genau einmal, danach kommt nie wieder eine Momentaufnahme.
// Genau das ist das Feldsymptom vom 2026-08-17/18 — die Live-Daten frieren ein,
// und die Oberflaeche sagt nichts.
//
// Diese Datei traegt deshalb DREI Dinge an EINER Stelle (REQ-OPS-053 (e)):
//   (1) den Fehlerweg (der Aufrufer haelt seinen Zustand wahr),
//   (2) das Protokoll (ueber `diagnoseSubscription`, KEINE zweite Form),
//   (3) die Rueckzugsstaffel samt Abbruch.
//
// ── DIE STAFFEL, und wie hier gezaehlt wird (REQ-OPS-053 (b)) ──────────────
//   2 s · 4 s · 8 s · 16 s · 30 s — **hoechstens fuenf Wiederaufnahmen je
//   Fehlerkette.** Die Zaehlung ist ausdruecklich diese:
//     • Das erste Abonnieren ist KEIN Versuch der Staffel (`attempt: 0`).
//     • Der erste Fehler plant Versuch 1 nach 2 s, der zweite Versuch 2 nach
//       4 s … der fuenfte Fehler plant Versuch 5 nach 30 s — damit ist der
//       letzte Wert der Staffel verbraucht.
//     • Der Fehler NACH dem fuenften Versuch plant nichts mehr: der Fehlzustand
//       bleibt stehen und ist von Hand bedienbar (REQ-OPS-054). **Einen sechsten
//       Versuch gibt es nie.**
//   Der Zaehler faellt beim ERSTEN erfolgreichen Schnappschuss auf 0 zurueck —
//   eine Fehlerkette ist damit beendet, nicht die Lebenszeit des Abos. **Im
//   selben Augenblick geht `onErholt` an den Aufrufer**, damit auch dessen
//   Fehlzustand faellt: ein Store, der nach der Wiederaufnahme weiter „tot"
//   meldet, waere dieselbe Falschaussage in der Gegenrichtung (nachgetragen am
//   2026-08-18, nachdem T-M21.5 den Zustand sichtbar gemacht hat).
//
// ── DER RECHTEFEHLER HAT SEIT T-M30.7 EINEN EIGENEN ERSTEN SCHRITT ─────────
// (REQ-SEC-028 (f), REQ-OPS-052)
// Ein `permission-denied` fuehrt **nicht mehr unmittelbar** in `onFehler`:
// zuerst wird der Anspruch EINMAL erzwungen aufgefrischt (`getIdToken(true)`)
// und das Abo EINMAL wiederholt. Erst wenn auch das abgewiesen wird, ist es ein
// echter Rechtefehler und geht den gewoehnlichen Weg (Meldung, Staffel).
// **Der Wiederholversuch zaehlt NICHT als Versuch der Staffel** — die fuenf
// Wiederaufnahmen aus (b) bleiben, was sie waren. Die drei Bildschirm-Ansichten
// nehmen daran nicht teil (`beiRechtefehler: 'melden'`, REQ-OPS-053 (f)).
//
// ── DER STILLE FALL (REQ-OPS-053 (c)) ──────────────────────────────────────
// Liegt im Augenblick des Fehlers KEIN angemeldeter Nutzer vor, ist die
// Ablehnung die erwartete Folge einer Abmeldung — auch der aus einem zweiten
// Tab desselben Profils. Dann wird NICHT wiederaufgenommen und KEIN Fehlzustand
// erzeugt; eine `info`-Zeile bleibt. Alles andere ist laut.
//
// **Gefragt wird `currentUser` der UEBERGEBENEN Anmeldung und NICHT der
// `authStore`.** Das ist Absicht und keine Bequemlichkeit: die Bildungsstelle
// liegt unter dem Store und darf ihn nicht voraussetzen — sonst waere sie ohne
// Pinia nicht pruefbar, und der `printJobService` (der keinen Store kennt)
// koennte sie nicht nutzen.
//
// *Bis zum 2026-09-08 stand hier „Gefragt wird `auth.currentUser`" — die Datei
// las die eine Anmeldung fest aus `@/firebase/config`. Seit der Trennung von
// Verwaltungs- und Bildschirm-Sitzung (T-M34.2, REQ-SC-109 (3)) gibt es zwei
// Instanzen; die Anmeldung kommt ueber `opts.anmeldung`, Vorgabe ist die
// Portal-Instanz. Berichtigt statt geloescht (REQ-OPS-036 Praez. 6).*
//
// ── DER ABBRUCH (REQ-OPS-053 (d)) ──────────────────────────────────────────
// Die zurueckgegebene Abmeldung beendet eine LAUFENDE Staffel: der Zeitgeber
// wird geloescht, ein spaeteres Abo entsteht nicht. Ohne diesen Punkt
// abonnierte ein Store nach dem Mandantenwechsel den VORIGEN Mandanten nach —
// schlechter als der Zustand vor diesem Task. Der Mandantenwechsel selbst
// braucht hier nichts Eigenes: jeder Store raeumt die vorige Anmeldung vor dem
// Neuabonnieren ab (das Muster gegen den Company-Switch-Bug), und genau das
// setzt Zaehler und Zeitgeber zurueck, weil das neue Abo ein neues Gebilde ist.
//
// ── GRENZEN, benannt ───────────────────────────────────────────────────────
//   • **Das ist keine Netzwiederherstellung und keine Offline-Faehigkeit**
//     (REQ-OPS-053 (g), REQ-RS-040). Beseitigt wird der ENDGUELTIGE Tod des
//     Listeners, nicht die Ursache des Fehlers. Eine Wiederaufnahme, die auf
//     dieselbe Ablehnung laeuft (fehlendes Recht, fehlender Index), scheitert
//     fuenfmal und endet im stehenden Fehlzustand — richtig so: sie soll das
//     Recht nicht erzwingen, sondern den Zustand benennen.
//   • **Keine Ansicht.** Was der Bediener sieht, ist T-M21.5; hier entsteht der
//     Zustand, den jene Ansicht zeigt (`wirdWiederaufgenommen: false`).
//   • **Kein Ersatz fuer die Wiederanmeldung der Bildschirm-Kanaele.** Laeuft
//     dort der Anspruch eines Anzeige-Tokens ab, ist der Rueckweg `screentoken`
//     und nicht ein Neuabonnieren (REQ-OPS-053 (f)) — das ist T-M21.7 und steht
//     bewusst NICHT hier.
//   • Protokolliert werden UEBERGAENGE, nicht Zustaende (REQ-OPS-055 (e)): eine
//     Zeile je Abonnement, je Fehler, je Aufgabe, je Wiederherstellung, je
//     Abmeldung — **keine je Momentaufnahme und keine je Dokument.**
// ─────────────────────────────────────────────────────────────────────────────

import {
  onSnapshot,
  type DocumentData,
  type DocumentReference,
  type FirestoreError,
  type Query,
  type Unsubscribe,
} from 'firebase/firestore';

// `auth` ist hier seit dem 2026-09-08 nur noch der VORGABEWERT von
// `opts.anmeldung` (T-M34.2, REQ-SC-109 (3)) — die Portal-Instanz `[DEFAULT]`.
// Die drei Bildschirm-Ansichten uebergeben `screenAuth`.
import { auth } from '@/firebase/config';
import { diagnoseSubscription } from '@/utils/diagnose';
import { frischeAnspruchAuf, RECHTEFEHLER_CODE, type AnmeldeQuelle } from '@/utils/anspruch';

/**
 * Die Rueckzugsstaffel in Millisekunden (REQ-OPS-053 (b)).
 *
 * Die Werte stehen in der Spec und werden hier nicht neu erfunden; ihre LAENGE
 * ist zugleich die Obergrenze der Versuche — es gibt keine zweite Konstante,
 * die mit ihr auseinanderlaufen koennte.
 */
export const RUECKZUGSSTAFFEL_MS: readonly number[] = [2_000, 4_000, 8_000, 16_000, 30_000];

/** Hoechstens fuenf Wiederaufnahmen je Fehlerkette (REQ-OPS-053 (b)). */
export const MAX_WIEDERAUFNAHMEN = RUECKZUGSSTAFFEL_MS.length;

/** Ein Abo-Ziel: eine Abfrage (Liste) oder ein einzelnes Dokument. */
export type LiveAboZiel = Query<DocumentData> | DocumentReference<DocumentData>;

/**
 * WAS BEI EINEM `permission-denied` GESCHIEHT (T-M30.7, REQ-SEC-028 (f)).
 *
 *   • `auffrischen` — **die Vorgabe und der Regelfall der Verwaltungsoberflaeche.**
 *     Der Anspruch wird EINMAL je Fehlerkette erzwungen aufgefrischt und das Abo
 *     EINMAL wiederholt, **bevor der Fehler an den Aufrufer geht** — ein
 *     Mitglied, das eben aufgenommen wurde, traegt seinen alten Anspruch sonst
 *     bis zu einer Stunde weiter und saehe statt seiner Daten eine
 *     Fehlermeldung. Scheitert der Wiederholversuch, ist es ein echter
 *     Rechtefehler und geht den gewoehnlichen Weg (REQ-OPS-052).
 *   • `melden` — **der Weg der drei Bildschirm-Ansichten** (REQ-OPS-053 (f)).
 *     Dort bedeutet `permission-denied` „Kanal umgestellt oder Anspruch
 *     entzogen"; der Rueckweg ist `screentoken` und NICHT ein frisches Token
 *     derselben Sitzung. Eine Auffrischung verzoegerte dort die erneute
 *     Anmeldung, ohne je etwas zu heilen.
 */
export type RechtefehlerWeg = 'auffrischen' | 'melden';

/**
 * Die Lage im Augenblick eines Fehlers — sie geht an den Aufrufer mit, damit
 * dieser (und spaeter die Ansicht aus T-M21.5) zwischen „es kommt zurueck" und
 * „die Staffel ist erschoepft" unterscheiden kann, ohne selbst zu zaehlen.
 */
export interface LiveAboFehlerLage {
  /** Nummer des Fehlschlags in der laufenden Fehlerkette (1 = der erste). */
  versuch: number;
  /** Wird eine Wiederaufnahme geplant? `false` = stehender Fehlzustand. */
  wirdWiederaufgenommen: boolean;
  /** Verzoegerung bis zur geplanten Wiederaufnahme; `null`, wenn keine folgt. */
  delayMs: number | null;
}

export interface LiveAboOptionen<TSnap> {
  /**
   * Name der Collection fuer das Protokoll — bei Listen-Abos.
   * Einer von `collection`/`path` gehoert gesetzt; ohne beides traegt die
   * Protokollzeile nicht, was gestorben ist (REQ-OPS-053 (a) (i)).
   */
  collection?: string;
  /** Dokumentpfad fuer das Protokoll — bei Abos auf ein einzelnes Dokument. */
  path?: string;
  /** Der Mandant, unter dem das Abo laeuft (REQ-OPS-053 (a) (i)). */
  companyId?: string | null;
  /**
   * Der Kanal, wenn das Abo einen einzelnen betrifft (die Warteschlange eines
   * Druckers, das Kanal-Dokument einer Bildschirm-Ansicht). Ohne ihn saehen im
   * Protokoll fuenf Warteschlangen gleich aus.
   */
  printerId?: string | null;
  /**
   * Baut das Firestore-Ziel. **Eine Funktion und kein Wert**, damit jede
   * Wiederaufnahme ein frisches Ziel bekommt — ein Abfrageobjekt, das einen
   * Cursor oder einen Zeitpunkt mitfuehrt, waere sonst beim fuenften Versuch
   * eine halbe Stunde alt.
   */
  ziel: () => LiveAboZiel;
  /** Die Momentaufnahme, wie sie der Aufrufer bisher im zweiten Argument bekam. */
  onData: (snap: TSnap) => void;
  /**
   * Der Fehlerweg des Aufrufers: **Ladezustand faellt, ein gefuehrtes
   * „abonniert"-Merkmal wird zurueckgenommen, die Fehlermeldung ist gesetzt**
   * (REQ-OPS-053 (a) (ii), die Aufloesung von OP-151). Das Protokollieren macht
   * diese Datei — der Aufrufer haelt nur seinen eigenen Zustand wahr.
   */
  onFehler: (fehler: FirestoreError, lage: LiveAboFehlerLage) => void;
  /**
   * DER RUECKWEG (REQ-OPS-053 (a), Gegenrichtung): gerufen beim ERSTEN
   * erfolgreichen Schnappschuss NACH mindestens einem Fehler.
   *
   * Hier nimmt der Aufrufer seinen Fehlzustand zurueck — `error = null`, das
   * „abonniert"-Merkmal wieder auf `true`. **Ohne diesen Rueckruf ist der
   * Fehlerweg nur in einer Richtung wahr:** die Staffel holt das Abo zurueck,
   * der Store behauptet aber weiter, er sei tot, und der Rahmen-Hinweis
   * (T-M21.5) meldet „nicht mehr live" ueber Daten, die gerade wieder
   * eintreffen. Das ist dieselbe Falschaussage wie das eingefrorene Bild, nur
   * mit umgekehrtem Vorzeichen.
   *
   * **Er wird beim ersten Schnappschuss eines gesunden Abos NICHT gerufen** —
   * sonst erzeugte jedes gesunde Abo ein Ereignis. Gezaehlt wird ausschliesslich
   * hier; ein Aufrufer, der selbst mitzaehlte, haette eine zweite Wahrheit.
   */
  onErholt?: () => void;
  /**
   * Der stille Fall (REQ-OPS-053 (c)): Abmeldung. Hier gehoert das hinein, was
   * WAHR bleibt — der Ladezustand faellt, das „abonniert"-Merkmal wird
   * zurueckgenommen —, aber **kein Fehlzustand**.
   */
  onStill?: () => void;
  /**
   * Der Weg bei einem Rechtefehler (REQ-SEC-028 (f)); Vorgabe `auffrischen`.
   *
   * **Die Vorgabe ist die weitere und nicht die engere**, und das ist Absicht:
   * eine neue Aufrufstelle der Verwaltungsoberflaeche soll die Pflicht aus (f)
   * erben, ohne sie zu kennen. Die zwei Stellen, an denen sie NICHT gilt,
   * stehen ausdruecklich und mit Begruendung in `useScreenChannel`.
   */
  beiRechtefehler?: RechtefehlerWeg;
  /**
   * DIE ANMELDUNG, AUF DER DIESES ABO LAEUFT (2026-09-08, T-M34.2 —
   * REQ-SC-109 (3)).
   *
   * Vorgabe ist die **Portal-Anmeldung** (`auth`, Instanz `[DEFAULT]`); jeder
   * Aufrufer der Verwaltungsoberflaeche bleibt damit unveraendert. Die drei
   * Bildschirm-Ansichten uebergeben hier `screenAuth` — sonst fragte der stille
   * Fall (REQ-OPS-053 (c)) und die Anspruchs-Auffrischung (REQ-SEC-028 (f))
   * eine Instanz, auf der an einer Bildschirm-Adresse niemand angemeldet ist,
   * und jeder Fehler des Bildschirms saehe wie eine Abmeldung aus.
   *
   * **Uebergeben statt gebildet** — dieselbe Bauform wie die Modus-Uebergabe in
   * REQ-SC-095 Praez. 1: diese Datei liegt unter den Stores und entscheidet
   * nicht, wessen Sitzung ein Aufrufer fuehrt.
   */
  anmeldung?: AnmeldeQuelle;
}

/**
 * Ist im Augenblick des Fehlers jemand angemeldet (REQ-OPS-053 (c))?
 *
 * *Bis zum 2026-09-08 fragte diese Funktion ohne Parameter die eine
 * `auth`-Instanz; seit der Trennung von Verwaltungs- und Bildschirm-Sitzung
 * (REQ-SC-109) fragt sie die des Aufrufers. Berichtigt statt geloescht,
 * REQ-OPS-036 Praez. 6.*
 */
function istAngemeldet(anmeldung: AnmeldeQuelle): boolean {
  try {
    return !!anmeldung?.currentUser;
  } catch {
    // Eine Umgebung ohne Firebase-Auth ist kein Grund, laut zu werden.
    return false;
  }
}

/**
 * Ein Live-Abo mit Fehlerweg, Protokoll und Rueckzugsstaffel.
 *
 * Rueckgabe ist eine gewoehnliche Abmeldefunktion — die Aufrufer behalten damit
 * ihre bisherige Bauform (`_unsub?.(); _unsub = null;`) und bekommen den
 * Abbruch der Staffel geschenkt (REQ-OPS-053 (d)).
 *
 * Mehrfaches Rufen der Abmeldung ist ausdruecklich erlaubt und still: die
 * Stores rufen sie vor jedem Neuabonnieren, und eine zweite Protokollzeile
 * waere Rauschen (REQ-OPS-055 (e)).
 */
export function liveAbo<TSnap>(opts: LiveAboOptionen<TSnap>): Unsubscribe {
  let unsub:    Unsubscribe | null = null;
  let zeitgeber: ReturnType<typeof setTimeout> | null = null;
  /** Fehlschlaege der laufenden Kette; 0 = kein Fehler seit dem letzten Erfolg. */
  let versuche  = 0;
  /** Endgueltig beendet — durch Abmeldung, stillen Fall oder erschoepfte Staffel. */
  let beendet   = false;
  /**
   * Ist der Anspruch in dieser Fehlerkette bereits aufgefrischt worden
   * (REQ-SEC-028 (f))? **EINMAL heisst einmal** — der zweite Rechtefehler geht
   * den gewoehnlichen Weg. Der Wert faellt beim ersten gelungenen
   * Schnappschuss zurueck, denn dann beginnt eine neue Kette.
   */
  let anspruchAufgefrischt = false;
  /**
   * Die Anmeldung dieses Abos (T-M34.2, REQ-SC-109 (3)). EINMAL aufgeloest und
   * nicht je Fehler: der Vorgabewert ist die Portal-Instanz, und ein Aufrufer,
   * der keine uebergibt, gehoert zur Verwaltungsoberflaeche.
   */
  const anmeldung: AnmeldeQuelle = opts.anmeldung ?? auth;

  /** Der gemeinsame Kontext jeder Protokollzeile (REQ-OPS-053 (a) (i)). */
  function kontext(): Record<string, unknown> {
    return {
      ...(opts.collection ? { collection: opts.collection } : {}),
      ...(opts.path       ? { path: opts.path }             : {}),
      ...(opts.companyId  ? { companyId: opts.companyId }   : {}),
      ...(opts.printerId  ? { printerId: opts.printerId }   : {}),
    };
  }

  function abonniere(): void {
    if (beendet) return;

    // Die Zeile steht VOR dem Abonnieren: eine Attrappe (und Firestore selbst)
    // darf die erste Momentaufnahme sofort liefern, und die Reihenfolge im
    // Protokoll soll den Ablauf zeigen, nicht die Aufrufreihenfolge des SDK.
    diagnoseSubscription('subscribed', { ...kontext(), attempt: versuche });

    let rueckgabe: unknown;
    try {
      rueckgabe = onSnapshot(
        opts.ziel() as Query<DocumentData>,
        (snap) => {
          if (beendet) return;
          anspruchAufgefrischt = false;   // eine neue Kette darf wieder auffrischen
          if (versuche > 0) {
            // Die Fehlerkette ist beendet — der Zaehler faellt zurueck
            // (REQ-OPS-053 (b)).
            diagnoseSubscription('recovered', { ...kontext(), attempt: versuche });
            versuche = 0;
            // ERST den Zustand des Aufrufers zuruecknehmen, DANN die Daten
            // liefern: die Momentaufnahme soll in einen Store fallen, der schon
            // wieder die Wahrheit ueber sich sagt.
            opts.onErholt?.();
          }
          opts.onData(snap as unknown as TSnap);
        },
        (fehler) => {
          if (beendet) return;
          behandleFehler(fehler);
        },
      );
    } catch (err: unknown) {
      // Wirft schon das Aufsetzen (etwa eine unzulaessige Abfrageform), waere
      // der Aufrufer sonst ohne jede Rueckmeldung — derselbe stumme Tod, nur
      // frueher.
      behandleFehler(err as FirestoreError);
      return;
    }
    unsub = typeof rueckgabe === 'function' ? (rueckgabe as Unsubscribe) : null;
  }

  function behandleFehler(fehler: FirestoreError): void {
    // Firestore hat den Listener bereits beendet; die Referenz darf nicht
    // stehenbleiben, sonst raeumte die Abmeldung ein totes Abo ab und liesse
    // das lebende (aus der Wiederaufnahme) stehen.
    unsub = null;

    const code = fehler?.code ?? 'unknown';

    if (!istAngemeldet(anmeldung)) {
      // Der stille Fall: erwartete Folge einer Abmeldung (REQ-OPS-053 (c)).
      beendet = true;
      diagnoseSubscription('silentEnd', { ...kontext(), code }, 'info');
      opts.onStill?.();
      return;
    }

    // ── DER EINE WIEDERHOLVERSUCH MIT FRISCHEM ANSPRUCH (REQ-SEC-028 (f)) ────
    // Er steht VOR der Staffel und VOR `onFehler`: der Fehler wird erst
    // angezeigt, wenn er auch mit frischem Anspruch besteht. Er zaehlt
    // ausdruecklich NICHT als Versuch der Staffel — die fuenf Wiederaufnahmen
    // aus REQ-OPS-053 (b) bleiben unangetastet, hier kommt genau einer hinzu.
    if (
      code === RECHTEFEHLER_CODE
      && (opts.beiRechtefehler ?? 'auffrischen') === 'auffrischen'
      && !anspruchAufgefrischt
    ) {
      anspruchAufgefrischt = true;
      diagnoseSubscription('claimRefresh', { ...kontext(), code }, 'warn');
      void (async () => {
        const erfolg = await frischeAnspruchAuf(
          opts.collection ?? opts.path ?? 'liveAbo',
          anmeldung,
        );
        if (beendet) return;
        // Kein frischer Anspruch zu bekommen? Dann ist der Fehler zu melden,
        // statt einen Versuch zu wiederholen, der dieselbe Antwort bekaeme.
        if (!erfolg) { meldeUndPlane(fehler, code); return; }
        abonniere();
      })();
      return;
    }

    meldeUndPlane(fehler, code);
  }

  /**
   * Der gewoehnliche Fehlerweg: melden, Staffel planen oder stehen lassen.
   *
   * Er liegt getrennt, weil ihn ZWEI Stellen erreichen — der unmittelbare
   * Fehler und der gescheiterte Wiederholversuch mit frischem Anspruch. Zwei
   * Abschriften desselben Weges liefen auseinander.
   */
  function meldeUndPlane(fehler: FirestoreError, code: string): void {
    versuche += 1;
    const wirdWiederaufgenommen = versuche <= MAX_WIEDERAUFNAHMEN;
    const delayMs = wirdWiederaufgenommen ? RUECKZUGSSTAFFEL_MS[versuche - 1]! : null;

    diagnoseSubscription(
      'failed',
      {
        ...kontext(),
        code,
        message: fehler?.message,
        attempt: versuche,
        ...(delayMs !== null ? { delayMs } : {}),
      },
      wirdWiederaufgenommen ? 'warn' : 'error',
    );

    // Erst den Zustand wahr machen, dann die Wiederaufnahme planen: eine
    // Attrappe mit gestellter Zeit koennte sonst den Zeitgeber vor dem
    // Zustandswechsel feuern lassen.
    opts.onFehler(fehler, { versuch: versuche, wirdWiederaufgenommen, delayMs });

    if (!wirdWiederaufgenommen) {
      // Die Staffel ist erschoepft: der Fehlzustand bleibt STEHEN und wird von
      // Hand bedient (REQ-OPS-054). Kein sechster Versuch.
      beendet = true;
      diagnoseSubscription('exhausted', { ...kontext(), code, attempt: versuche }, 'error');
      return;
    }

    zeitgeber = setTimeout(() => {
      zeitgeber = null;
      abonniere();
    }, delayMs!);
  }

  abonniere();

  return () => {
    if (beendet && !unsub && !zeitgeber) return;   // schon beendet: still
    beendet = true;
    if (zeitgeber) { clearTimeout(zeitgeber); zeitgeber = null; }
    const laufend = unsub;
    unsub = null;
    try { laufend?.(); } catch { /* eine Abmeldung darf ihren Aufrufer nicht faellen */ }
    diagnoseSubscription('unsubscribed', kontext());
  };
}
